import React from 'react';
import cn from 'classnames';
import { Checkbox } from '@/design-system/components/Basic/Checkbox';

export interface MultiAnswerOption {
  label: string;
  value: string;
}

export interface MultiAnswerListProps {
  options: MultiAnswerOption[];
  name: string;
  selectedValues?: string[];
  /** When provided, reveals quiz feedback: correct answers highlighted in teal, wrong selections in red. */
  correctValues?: string[];
  onChange?: (values: string[]) => void;
  className?: string;
}

export const MultiAnswerList: React.FC<MultiAnswerListProps> = ({
  options,
  name,
  selectedValues = [],
  correctValues,
  onChange,
  className,
}) => {
  const isAnswered = correctValues !== undefined;

  return (
    <div className={cn('flex flex-col gap-6', className)}>
      {options.map((option) => {
        const isSelected = selectedValues.includes(option.value);
        const isCorrect = correctValues?.includes(option.value) ?? false;
        const showAsCorrect = isAnswered && isCorrect;
        const showAsIncorrect = isAnswered && isSelected && !isCorrect;

        return (
          <Checkbox
            key={option.value}
            id={`${name}-${option.value}`}
            name={name}
            value={option.value}
            label={option.label}
            checked={isSelected || showAsCorrect}
            correct={showAsCorrect}
            error={showAsIncorrect}
            labelClassName="!w-full rounded-lg"
            onChange={(event) => {
              if (isAnswered) return;

              const nextValues = event.target.checked
                ? [...selectedValues, option.value]
                : selectedValues.filter((value) => value !== option.value);
              onChange?.(nextValues);
            }}
          />
        );
      })}
    </div>
  );
};

export default MultiAnswerList;
